import { Swiper, Mousewheel, Pagination, Navigation } from 'swiper'

Swiper.use([Mousewheel, Pagination, Navigation])

class Slider {
  constructor() {
    this.initialize()
  }

  initialize() {
    this.setInitialParams();
    this.bindUI();
    this.initSliders();
  }

  bindUI() {
    this.mqMax = window.matchMedia( "(max-width: 1024px)" );
    this.ui = {}
    this.ui.$sliders = document.querySelectorAll('.js-slider')
  }

  setInitialParams() {
    this.sliders = []
  }

  initSliders() {
    [].forEach.call(this.ui.$sliders, ($slider, index) => {
      this.checkTypeSlider($slider, index)
    })
  }

  checkTypeSlider($slider, index) {
    const s1 = $slider.classList.contains('js-slider-project')
    const s2 = $slider.classList.contains('js-slider-archive')
    const s3 = $slider.classList.contains('js-slider-mobile')

    if(s1) {
      this.initProjectSlider($slider, index)
    } else if (s2) {
      this.initArchiveSlider($slider, index)
    } else if (this.mqMax.matches & s3) {
      this.initMobileSlider($slider, index)
    }
  }

  initProjectSlider($slider, index) {
    const currentSlider = new Swiper($slider, {
      slidesPerView: 1.3,
      spaceBetween: 15,
      centeredSlides: true,
      loop: true,
      pagination: {
        el: ".js-dots",
      },
      navigation: {
        nextEl: ".js-next",
        prevEl: ".js-prev",
      },
      breakpoints: {
        1024: {
          slidesPerView: 3
        }
      }
    })

    this.sliders.push(currentSlider)
  }

  initArchiveSlider($slider, index) {
    const currentSlider = new Swiper($slider, {
      slidesPerView: 1.3,
      spaceBetween: 15,
      freeMode: true,
      speed: 800,
      loop: true,
      centeredSlides: true,
      mousewheel: true,
      pagination: {
        el: '.js-pagination',
        type: 'progressbar'
      },
      navigation: {
        nextEl: ".js-next",
        prevEl: ".js-prev",
      },
      breakpoints: {
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
          loop: false,
        }
      }
    })

    this.sliders.push(currentSlider)
  }

  initMobileSlider($slider, index) {
    const currentSlider = new Swiper($slider, {
      slidesPerView: 1.3,
      spaceBetween: 15,
      centeredSlides: true,
      loop: true,
    })

    this.sliders.push(currentSlider)
  }
}

export default Slider
